export default "__VITE_ASSET__BGBBDU6U__"